export default __webpack_public_path__ + "assets/icons/checked-active.5f5e76ce.svg";